var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"menu-btn center-all-col"},'div',_vm.$attrs,false),_vm.$listeners),[_c('h3',{staticClass:"center-all"},[_vm._v(_vm._s(_vm.text))]),(_vm.additional)?_c('span',{staticClass:"center-all"},[_vm._v(" "+_vm._s(_vm.additional)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }